import React from 'react';
import ActiveCouponsIconSvg from '../../../../../../assets/icons/active-coupons-icon.svg';

export const TotalActiveCouponsIcon: React.FC<{ className?: string }> = ({ className = '' }) => {
    return (
        <img
            src={ActiveCouponsIconSvg}
            alt="Total Active Coupons"
            className={className}
        />
    );
};
